import { Button } from "@merge-api/merge-javascript-shared";
import { useMergeLink } from "@mergeapi/react-merge-link";
import React, { useState } from "react";

interface Props {
  /**
   * Called when a new account is linked via the linking flow.
   */
  linkToken: string;
  tenantConfig: {} | { tenantConfig: { apiBaseURL: string } };
  onNewLinkedAccount: (wasSuccess: boolean) => void;
  accountLimitReached?: boolean;
  disabled?: boolean;
}

const ProdMergeLinkActionButton = ({
  linkToken,
  tenantConfig,
  onNewLinkedAccount,
  accountLimitReached,
  disabled,
}: Props) => {
  const [wasSuccess, setWasSuccess] = useState(false);
  const { open, isReady } = useMergeLink({
    linkToken: linkToken,
    onSuccess: () => {
      setWasSuccess(true);
    },
    onExit: () => onNewLinkedAccount(wasSuccess),
    ...tenantConfig,
  });

  return (
    <Button
      onClick={() => {
        setWasSuccess(false);
        open();
      }}
      disabled={disabled || (accountLimitReached === true ? true : !isReady)}
    >
      Create test Linked Account
    </Button>
  );
};

export default ProdMergeLinkActionButton;
